import { Component, OnInit, ViewChild, Input, AfterViewInit } from "@angular/core";
import { GroupPanel } from '../../interfaces';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { CtTableComponent, TableMetaData } from '../../../../framework-modules/elements/ct-table/component'
import { SessionComponent } from '../../component';
import { RowToColMeta, FilterRequest } from 'src/app/framework-modules/formdata/form/types';
import { EligibilityListForm, EligibilityListFd, EligibilityListVo } from 'src/app/framework-modules/formdata/gen/eligibilityListForm';
import { TaughtSectionSelectionForm, TaughtSectionSelectionFd } from 'src/app/framework-modules/formdata/gen/taughtSectionSelectionForm';
import { MessageService } from 'src/app/services/messageService';

@Component({
  selector: "condone-attendance-list",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})


export class CondoneAttendanceListComponent implements OnInit, AfterViewInit {
  @ViewChild("gridTable", { static: false }) gtable: CtTableComponent;
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: SessionComponent;
  /**
 * for selecting subjectSection
 */
  form: TaughtSectionSelectionForm;
  fd: TaughtSectionSelectionFd;
  selectedSection = ''

  /**
 * for getting students-list
 */
  fd1: EligibilityListFd;

  tableData: TableMetaData;

  constructor(private sa: ServiceAgent, private ms: MessageService) {
    this.form = TaughtSectionSelectionForm.getInstance();
    this.fd = this.form.newFormData(this.sa);
    this.fd1 = EligibilityListForm.getInstance().newFormData(this.sa);
  }

  ngOnInit() {
    this.initTable();
  }

  ngAfterViewInit() {
    this.gtable.update();
  }

  private initTable() {
    this.tableData = {
      data: [],
      metaData: {
        column_names: [
          "name",
          "usn",
          "overallAttendance",
          "cieMarks",
          "isCondoned"
        ],
        display_names: {
          name: "Name",
          usn: "USN",
          overallAttendance: "Attendance",
          cieMarks: "CIE Marks",
          isCondoned:"Condoned?"
        },
        search: true,
        placeholder: "Search by Student Name, Student USN",
        styleAttribute: {
          "isCondoned": [
            {comp: '=', value: 'CONDONED', style:{'color':'orange', 'font-weight': 600}},
            {comp: '=', value: 'NOT CONDONED', style:{'color':'black', 'font-weight': 600}},
           ]
        }
      }
    };
  }

  sectionChanged(id: string) {
    if (this.selectedSection == id ) {
      return;
    }
    if (id) {
      this.getData(id);
    }else{
      this.selectedSection = id;
    }
  }

  private getData(id: string) {
    const f: FilterRequest = {
      conditions: { subjectSectionId: { comp: "=", value: id } },
      sort: { usn: "asc" }
    };

    this.fd1.filter(f).subscribe({
      next: data => {
        data.forEach(student =>{
          if(student.isCondoned){
            student.isCondoned = "CONDONED"
          }
          else{
            student.isCondoned = "NOT CONDONED"
          }
        })
        this.selectedSection = id;
        this.tableData.data = data;
        if(!data.length){
          this.ms.showInfo('No students found for this section.');
        }
        this.gtable.update();
      },
      error: msg => {
        console.error(msg);
        this.ms.showError('Server returned with an error message. ');
      }
    });
  }

  gotoEdit() {
    if (!this.selectedSection) {
      this.ms.showError('Please select a subject-section');
    } else {
      this.parentPanel.navigate('CondoneAttendanceEdit', this.selectedSection);
    }
  }
}